import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Id } from 'src/app/models/database/types/id.model';

@Component({
  selector: 'app-edit-datasheet-sections-order',
  templateUrl: './edit-datasheet-sections-order.component.html',
  styleUrls: ['./edit-datasheet-sections-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditDatasheetSectionsOrderComponent implements OnInit {
  @Input() datasheetId: Id
  @Input() tooltipPlacement: string = 'left'

  @ViewChild('modal') modal: TemplateRef<any>
  modalReference: NgbModalRef

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }

  openModal(): void {
    this.modalReference = this.modalService.open(this.modal, { scrollable: true })
  }
}
